import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";

import { productsActions, statsActions, usersActions } from "./store";
import theme from "./theme";
import Drawer from "./drawer/drawer";
import { useNavigate } from "react-router-dom";
import { getWithExpiry } from "./common/util/localstorage";
import { maintenancesActions } from "./store/maintenances";
import { clientsActions } from "./store/clients";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Token, setToken] = useState(null);

  const desktop = useMediaQuery(theme.breakpoints.up("md"));
  const _isAdministrator = useSelector((state) => state.session.user.administrator);

  const fetchProductsData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_NAME}/products`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
        },
      });
      if (response.ok) {
        dispatch(productsActions.setItems(await response.json()));
      }
      if (response.status === 401) {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
const fetchClientsData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_NAME}/clients`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
        },
      });
      if (response.ok) {
        dispatch(clientsActions.setItems(await response.json()));
      }
      if (response.status === 401) {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  const fetchMaintenancesData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_NAME}/maintenances`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
        },
      });
      if (response.ok) {
        dispatch(maintenancesActions.setItems(await response.json()));
      }
      if (response.status === 401) {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
    const fetchMaintenancesstatsData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_NAME}/maintenances`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
        },
      });
      if (response.ok) {
        dispatch(statsActions.setItems(await response.json()));
      }
      if (response.status === 401) {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  const fetchUsersData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_NAME}/users`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getWithExpiry("TOKEN")}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        dispatch(usersActions.setItems(data));
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    if (!getWithExpiry("TOKEN")) {
      navigate("/login");
    } else {
      fetchProductsData();
      fetchClientsData();
      fetchMaintenancesData();
      fetchMaintenancesstatsData();

      if (_isAdministrator) {
        fetchUsersData();
      }
    }
  }, []);

  return <Drawer />;
}

export default App;
